'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseScreenReaderMessage = require('@bibliocommons/base-screen-reader-message');

var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);

var _baseIcons = require('@bibliocommons/base-icons');

require('../styles/HelpLink.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var defaultText = _react2.default.createElement(
  _baseScreenReaderMessage2.default,
  null,
  _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_learn_more_about_feature' })
);

var openHelpWindow = function openHelpWindow(e, url) {
  e.preventDefault();
  window.open(url, '_blank', 'height=600,width=750,toolbar=no,scrollbars=yes,status=no,resizable=yes,location=no,menuBar=no');
};

function HelpLink(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$page = _ref.page,
      page = _ref$page === undefined ? '' : _ref$page,
      _ref$currentLanguage = _ref.currentLanguage,
      currentLanguage = _ref$currentLanguage === undefined ? 'en-US' : _ref$currentLanguage,
      _ref$showIcon = _ref.showIcon,
      showIcon = _ref$showIcon === undefined ? true : _ref$showIcon,
      _ref$children = _ref.children,
      children = _ref$children === undefined ? defaultText : _ref$children,
      props = _objectWithoutProperties(_ref, ['className', 'page', 'currentLanguage', 'showIcon', 'children']);

  var classNames = 'cp-help-link ' + className;
  var helpParts = page.split('#');
  var url = '';
  var formattedLocale = function (loc) {
    switch (loc.toLowerCase()) {
      case 'fr-ca':
        return 'fr';
      case 'es-es':
        return 'es';
      case 'ja-ja':
        return 'ja';
      case 'ru-ru':
        return 'ru';
      case 'ja-ja':
        return 'ja';
      case 'zh-cn':
        return 'zh-hans';
      case 'zh-tw':
        return 'zh-hant';
      default:
        return '';
    }
  }(currentLanguage.toLowerCase());

  if (helpParts[0]) {
    url = helpParts[0].replace('_', '-');
  }

  if (url && helpParts[1]) {
    url = helpParts[0].replace('_', '-') + '#' + helpParts[1];
  }

  if (formattedLocale) {
    formattedLocale = '/' + formattedLocale;
  }

  if (url) {
    url = '/' + url;
  }

  var href = 'http://help.bibliocommons.com' + formattedLocale + url;

  return _react2.default.createElement(
    'a',
    _extends({
      onClick: function onClick(e) {
        return openHelpWindow(e, href);
      },
      className: classNames,
      href: href,
      target: '_blank',
      rel: 'noopener noreferrer'
    }, props),
    showIcon ? _react2.default.createElement(_baseIcons.Info, null) : null,
    children
  );
}

HelpLink.propTypes = {
  className: _react2.default.PropTypes.string,
  page: _react2.default.PropTypes.string.isRequired,
  showIcon: _react2.default.PropTypes.bool,
  children: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.node), _react2.default.PropTypes.node]),
  currentLanguage: _react2.default.PropTypes.string
};

exports.default = HelpLink;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-help-link/lib/components/HelpLink.component.js
// module id = 1485
// module chunks = 1